/*eslint-disable*/
import React, { Component } from "react";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

class Login extends Component {
  render() {
    return (
      <>
              <footer className="footer">
        <Row className="align-items-center justify-content-xl-between">
          <Col xl="6">
            <div className="copyright text-center text-xl-left text-muted">
              © 2021{" "}
              <a
                className="font-weight-bold ml-1"
                href="https://b4finance.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                front-admin
              </a>
            </div>
          </Col>

          <Col xl="6">
            <Nav className="nav-footer justify-content-center justify-content-xl-end">
              <NavItem>
                <NavLink
                  href="https://b4finance.com"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  B4Finance
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  href="https://www.b4finance.com/about-us"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  About Us
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
      </footer>
      </>
    );
  }
}

export default Login;
